export default function WorkspaceThemeColors() {
  return [
    {
      background:'transparent',
      opacity:1,
    },

    {
      background:'magenta',
      opacity:0.08,
    },

    {
      background:'cyan',
      opacity:0.1,
    },



    {
      background:'lime',
      opacity:0.08,
    },


    {
      background:'red',
      opacity:0.05,
    },

    {
      background:'purple',
      opacity:0.08,
    },
    {
      background:'orange',
      opacity:0.15,
    },

    {
      background:'red',
      opacity:0.1,
    },


    {
      background:'blue',
      opacity:0.1,
    },

    {
      background:'yellow',
      opacity:0.2,
    },

    {
      background:'black',
      opacity:0.1,
    },
  ]
}

